var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.theme ? _vm.theme : 'btnL2 w-5/12',attrs:{"dir":"rtl"},on:{"click":function($event){return _vm.$emit('action')}}},[(_vm.text)?_c('h1',{staticClass:"btnTxt first-letter:uppercase"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_c('svg-app',{attrs:{"type":_vm.svg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }